<template>
  <div>
    <IdeaColumnTemp :list="list"/>
  </div>
</template>

<script>
import IdeaColumnTemp from '../components/ideaColumnTemp.vue'
export default {
    name: "PreviewMaterialModal",
    props: {
        list: {
            type: Array,
            default: () => {
                return [];
            },
        },
    },
    components: {
        IdeaColumnTemp,
    },
}
</script>

<style lang="scss" scoped>

</style>